var crisisBanner = function() {
    var $crisisBanner,
        $crisisBannerInner,
        $closeBtn,
        $mobileMenuTrigger,
        $crisisAlertTrigger,
        $searchTrigger;

    function closeCrisisBanner() {
        $crisisBanner.slideUp();
    }

    function bindEvents() {
        $closeBtn.on('click touchend', closeCrisisBanner);
        $mobileMenuTrigger.on('click touchend', closeCrisisBanner);
        $crisisAlertTrigger.on('click touchend', closeCrisisBanner);
        $searchTrigger.on('click touchend', closeCrisisBanner);
    }

    function addMultiplyBlendMode(){
        var supportsCSS = !!((window.CSS && window.CSS.supports) || false);
        var supportBlendModeMultiply = supportsCSS && window.CSS.supports("mix-blend-mode","multiply");
        if(supportBlendModeMultiply){
            $crisisBannerInner.addClass('support-blend-mode');
        }
    }

    function init() {
        $crisisBanner = $('.crisis-banner');
        $crisisBannerInner = $('.crisis-banner__inner');
        $mobileMenuTrigger = $('.header-mobile__trigger');
        $crisisAlertTrigger = $('.nav-alert__button');
        $searchTrigger = $('.nav-search__button');

        if ($crisisBanner.length > 0) {
            $closeBtn = $('.crisis-banner__close-trigger');
            addMultiplyBlendMode();
            bindEvents();
        }
    }

    return {
        init: init
    };
}();

$(function() {
    crisisBanner.init();
});